import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./lander/lander.component').then(m => m.LanderComponent)
	},
	{
		path: 'job-list',
		loadComponent: () => import('./job-list/job-list.component').then(m => m.JobListComponent)
	},
	{
		path: 'job-preview/:jrid',
		loadComponent: () => import('./job-preview/job-preview.component').then(m => m.JobPreviewComponent)
	},
	{
		path: 'job-preview/:jrid/:job-not-found',
		loadComponent: () => import('./job-preview/job-preview.component').then(m => m.JobPreviewComponent)
	},
	{
		path: 'registration',
		loadComponent: () => import('./shared/registration-option2/registration-option2.component').then(m => m.RegistrationOption2Component)
	},
	{
		path: 'verify/:code',
		loadComponent: () => import('./lander/lander.component').then(m => m.LanderComponent)
	},
	{
		path: 'reset-password',
		loadComponent: () => import('./reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
	},
	{
		path: 'saved-jobs',
		loadComponent: () => import('./my-jobs/saved-jobs/saved-jobs.component').then(m => m.SavedJobsComponent),
		canActivate: [MsalGuard]
	},
	{
		path: 'applications',
		loadComponent: () => import('./my-jobs/applications/applications.component').then(m => m.ApplicationsComponent),
		canActivate: [MsalGuard]
	},
	{
		path: 'referrals',
		loadComponent: () => import('./my-jobs/referrals/referrals.component').then(m => m.ReferralsComponent),
		canActivate: [MsalGuard]
	},
	{
		path: 'candidate-profile',
		loadChildren: () =>
			import('./candidate-profile/candidate-profile.module').then(
				(m) => m.CandidateProfileModule
			),
		canActivate: [MsalGuard]
	},
	{
		path: 'privacy-policy',
		loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
	},
	{
		path: 'terms-of-service',
		loadComponent: () => import('./terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent)
	},
	{
		path: 'resume-preview/:guid',
		loadComponent: () => import('./resume-quick-link/resume-quick-link.component').then(m => m.ResumeQuickLinkComponent)
	},
	{
		path: 'questions',
		loadComponent: () => import('./signup-questions/signup-questions.component').then(m => m.SignupQuestionsComponent)
	},
	{ path: '**', loadComponent: () => import('./lander/lander.component').then(m => m.LanderComponent) }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {}
